export const adminhost = "home.alpharepservice.com";
export const superadminhost = "admin.alpharepservice.com";
export const staginghost = "v2.alpharepservice.com";
export const marketinghost = "alpharepservice.com"
